import { render, staticRenderFns } from "./Password-change-modal.vue?vue&type=template&id=8da3d6da&scoped=true&"
import script from "./Password-change-modal.vue?vue&type=script&lang=js&"
export * from "./Password-change-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da3d6da",
  null
  
)

export default component.exports